import './index.css';
import DebtProjects from './DebtProject/DebtProjects';
import EquityInvestments from './EquityInvestment/EquityInvestments';
import line4 from '../../../assets/shapes_svg/companydetail/line4.svg';
import './tableequityinvestment.css';
import './tabledebtproject.css';
import { useTranslation } from 'react-i18next';

const Investments = () => {
    const {t} = useTranslation()
    return ( 
        <div className="investments__info__bubble">
            <div className="investments__info__row">
                <h5>{t('Equity Investment')}</h5>
                <div style={{flexDirection:"row",flexWrap:"wrap"}}>
                    <EquityInvestments/>
                </div>
            </div>
            <img src={line4} alt="line" />
            <div className="investments__info__row">
                <h5>{t('Debt/Project')}</h5>
                <div style={{flexDirection:"row",flexWrap:"wrap"}}>
                    <DebtProjects/>
                </div>
            </div>
        </div>
     );
}
 
export default Investments;